export enum Education {
  ELEMENTARY_SCHOOL = 'elementary_school',
  MIDDLE_SCHOOL = 'middle_school',
  HIGH_SCHOOL = 'high_school',
  UNIVERSITY = 'university',
}
